import React, { useState, useMemo, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import Tree from "react-d3-tree";
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import { ScrollModule } from '../ScrollModule';
import ScrollArea from 'react-scrollbar';
import { GroupsService } from '../../services';

const WRAPPER_CONFIGURATION = {
  style: {
    border: "0px solid black",
    width: "350px",
    height: "95px",
    x: -175,
    y: -80
  }
};

const buildTree = (data, businessStructure) => {
  let children = [];
  businessStructure.children.forEach((childBusinessStructure) => {
      buildTree(children, childBusinessStructure);
  });

  let entry = { name: "", businessStructure: businessStructure };
  if (children.length > 0) {
      entry["children"] = children;
  }
  data.push(entry);
};

const Groups = ({ me }) => {
  const [loading, setLoading] = useState(true);
  const [treeData, setTreeData] = useState(null);

  const treeContainer = useRef();

  useEffect(() => {
    setLoading(true);
    GroupsService.listAll().then(({ groups }) => {
        let data = [];
        buildTree(data, groups[0]);
        setTreeData(data);
    }).catch((error) => {
      console.error(error);      
    }).finally(() => setLoading(false));
  }, [me]);

  const translate = useMemo(() => {
    if (treeContainer.current && treeData) {
      const dimensions = treeContainer.current.getBoundingClientRect();
      return {
          x: dimensions.width / 2 + (window.innerWidth < 800 ? 150 : 0),
          y: 100,
      };
    } else {
      return { x: 0, y: 0 };
    }
  }, [treeContainer, treeData]);

  return (
      <div>
        <div className="row">
          <PageTitle title={i18next.t('pages.business-structure.header', {name: me.enterprise.name})} />
        </div>

        <div className="op-content-box">
          <ScrollModule/>
          <ScrollArea speed={0.8} className="scroll-container" contentClassName="scrollable-content" horizontal={true} >

            <div className="op-group-structure">
              <div className="clearfix" style={{ width: "100%", height: "100vh" }} ref={treeContainer}>
                { loading && <div className='loader'>Loading...</div> }
                { !loading && 
                  <Tree
                    data={treeData}
                    zoomable={false}
                    collapsible={false}
                    pathFunc="diagonal"
                    allowForeignObjects
                    nodeSvgShape={{ shape: "none" }}
                    translate={translate}
                    nodeSize={{x: 360, y: 135}}
                    orientation="vertical"
                    transitionDuration={0}
                    nodeLabelComponent={{ render: <Card />, foreignObjectWrapper: WRAPPER_CONFIGURATION }}
                  />
                }
              </div>
            </div>

          </ScrollArea>
        </div>
      </div>
  );
}

const Card = ({ nodeData }) => (
    <div className="business-structure-item">
      <div>
        <div className="card-body">
          <h5>{nodeData.businessStructure.name}</h5>
          <div className='card-data'>
            ID: {nodeData.businessStructure.externalId}
          </div>
        </div>
      </div>
    </div>
);

export default connect(state => ({ me: state.user.me }))(Groups);
